<div class="assignment-attach-file-attachemnt">
    <label class="control-label">{{fileLabel}}</label>
    <input data-classbutton="browse-button" (change)="UploadFileAttachement($event,FileUploadAttachementDetail);"
      class="form-control filestyle-1" data-input="false" data-text="Browse file" id="tempAttachmentFilePath"
      style="position: absolute; clip: rect(0px, 0px, 0px, 0px);" type="file" accept="{{AcceptedFileType}}">
    <div class="bootstrap-filestyle input-group">
      <span class="group-span-filestyle " tabindex="0">
        <label for="tempAttachmentFilePath" class="btn btn-default ">
          <span class="icon-span-filestyle glyphicon glyphicon-folder-open"></span>
          <span class="buttonText" >{{bs.getResource('rbKey_Gmfctn_ChsFlLBL')}}</span>
        </label>
      </span>
    </div>
    <div class="assignment-attach-file-info-attachemnt" >
        <div class="progress-bar-div-attachemnt">
            <div class="pro-bar-attachemnt" >
                <div class="pro-bar-inn-attachemnt"  [style.width]="FileUploadAttachementDetail['FileProgess']+'%'"></div>
            </div>
        </div>
        <br>
        <span class="fileUploadFormat-attachemnt">{{FileUploadAttachementDetail['FileName']}}</span>
        <span *ngIf="FileSizeAttachement()" class="fileUploadSize-attachemnt">{{bs.getResource('rbkey_FlSzMSG')}}{{FileUploadAttachementDetail['FileSize']}}</span>

    </div>
    <div class="assignment-attach-file-validation-attachemnt" *ngIf="IsFileUploadTokenExpired()">
      {{bs.getResource('rbkey_InvldFlUpldRvstLBL')}}
  </div>
    <div class="assignment-attach-file-validation-attachemnt" *ngIf="IsVirusInfectedFileAttachement()">
        {{bs.getResource('rbkey_VrsFlMSG')}}
    </div>
    <div class="assignment-attach-file-validation-attachemnt"  *ngIf="IsValidFileNameAttachement()">
       {{bs.getResource('rbkey_SpclChrctrFlMSG')}}
    </div>
    <div class="assignment-attach-file-validation-attachemnt"  *ngIf="IsValidFileTypeAttachement()">
        {{bs.getResource('rbkey_FlTypNtAllwMSG')}}
    </div>
    <div class="assignment-attach-file-validation-attachemnt"  *ngIf="IsValidFileLengthAttachement()">
          {{bs.getResource('rbkey_FlNmLngthMSG1')}}
    </div>

    <div class="assignment-attach-file-note-attachemnt">
      <!-- Note: <br>
      - Maximum file size for upload is {{AllowFileSize}}mb<br>
      - File formats allowed are:<br>
        {{AllowFileType}} -->
        {{bs.getResource('rbkey_NtLBL')}}: <br>
        -{{bs.getResource('rbkey_MxmmSzMSG')}}{{AllowFileSizeAttachement}}mb<br>
        - {{bs.getResource('rbkey_FlUpldMsg')}}:<br>
        <div class="span-filetype"   [innerHTML]="AllowFileTypeAttachement"> </div>

    </div>
    <input   id="encryptedAttachementPath" value="{{FileUploadAttachementDetail['SaveFilePath']}}"  type="hidden">
    <input   id="fileSize" value="{{FileUploadAttachementDetail['FileSize']}}"  type="hidden">
    </div>
